import styled from "styled-components";
import { theme } from "../../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Label = styled.div`
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    line-height: 2rem;
    text-align: start;
    color: ${theme.colors.primaryBlack};
`;

export const Value = styled.div`
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
    line-height: 2rem;
    text-align: end;
    color: ${theme.colors.primaryBlack};
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;

    & > div {
        display: flex;
        align-items: center;
    }

    ${Label} + button {
        position: relative;
        top: 1px;
        margin-left: ${theme.space[1] / 2}px;
    }

    html[dir="rtl"] & {
        ${Label} + button {
            margin-left: 0;
            margin-right: ${theme.space[1] / 2}px;
        }
    }
`;
